// extracted by mini-css-extract-plugin
export default {"operationArea":"List_operationArea__k5ak9","tabs":"List_tabs__Cfbf5"};